import { t } from '../i18n/lingua'

/**
 * «Sfruttata attivamente (CISA KEV)»: the vulnerability is in the CISA Known
 * Exploited Vulnerabilities catalogue, i.e. there is evidence of attacks in
 * progress. Wherever the phrase appears it links to the CVE in that catalogue
 * (or to the catalogue when the CVE is not known), with the explanation on
 * hover.
 */

const CATALOGO = 'https://www.cisa.gov/known-exploited-vulnerabilities-catalog'

export function urlKev(cve?: string | null): string {
  return cve && /^CVE-\d{4}-\d+$/i.test(cve)
    ? `${CATALOGO}?search_api_fulltext=${encodeURIComponent(cve.toUpperCase())}`
    : CATALOGO
}

export function spiegazioneKev(): string {
  return t('Nel catalogo KEV della CISA: ci sono prove che venga già usata negli attacchi. Va corretta prima delle altre, qualunque sia il punteggio.')
}

/** The first CVE of a finding's evidence, whatever engine wrote it. */
export function cveDaProva(evidence: Record<string, unknown> | null | undefined): string | null {
  if (!evidence) return null
  const candidati: unknown[] = [
    evidence.cve,
    ...(Array.isArray(evidence.cve_principali) ? evidence.cve_principali : []),
    ...(Array.isArray(evidence.cves) ? evidence.cves : []),
    ...(Array.isArray(evidence.cve_ids) ? evidence.cve_ids : []),
  ]
  const primo = candidati.find((c) => typeof c === 'string' && /^CVE-\d{4}-\d+$/i.test(c))
  return (primo as string | undefined) ?? null
}

/** The phrase as a link, styled as the red badge or as plain text. */
export function LinkKev({ cve, badge = true, testo }: { cve?: string | null; badge?: boolean; testo?: string }) {
  return (
    <a href={urlKev(cve)} target="_blank" rel="noreferrer noopener" title={spiegazioneKev()}
      className={badge ? 'badge badge--error' : undefined} onClick={(e) => e.stopPropagation()}>
      {testo ?? t('sfruttata attivamente (CISA KEV)')}
    </a>
  )
}

/** A translated text in which the phrase (singular or plural, any language)
 *  becomes the link. */
const FRASE = /(sfruttat[ae] attivamente \(CISA KEV\)|actively exploited \(CISA KEV\)|activement exploitées? \(CISA KEV\))/i

export function TestoConKev({ testo, cve }: { testo: string; cve?: string | null }) {
  const parti = testo.split(FRASE)
  if (parti.length === 1) return <>{testo}</>
  return (
    <>
      {parti.map((p, i) => (FRASE.test(p) ? <LinkKev key={i} cve={cve} badge={false} testo={p} /> : <span key={i}>{p}</span>))}
    </>
  )
}
